<mat-toolbar class="mat-footer">

    <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

        <a href="https://weblancertechnologies.com/"
            target="_blank" mat-button fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="start center" class="vTech">
            <!-- <mat-icon class="s-16 mr-sm-4">shopping_cart</mat-icon> -->
            <span style="font-weight: 1000; display: flex;" ><h5 style="color: #070707;" class="footer_h5">powered by:</h5>&nbsp;&nbsp;<span style="color: white;" class="footer_span">WEBLANCER TECHNOLOGIES PVT. LTD.</span></span>
        </a>

        <!-- <div fxLayout="row"  fxLayoutAlign="start center" fxHide fxShow.gt-xs>
            <a mat-button href="{{androidLink}}" target="_blank" *ngIf="androidAppLink"  class="and-ios">
                <i class="pi pi-android" style="font-size: 1.5rem; margin-right: 2px;"></i>
                <span class="icon-name">Android</span>
            </a>&nbsp;&nbsp;&nbsp;&nbsp;
            <a mat-button href="{{iosLink}}" *ngIf="iosLink" target="_blank"  class="and-ios">
                <i class="pi pi-apple s-16 mr-sm-4" style="font-size: 1rem;"></i>
                <span style="margin-top: 4px;" class="icon-name">IOS</span>
            </a>
        </div> -->
    </div>

</mat-toolbar>